
<script>

import { Pie } from 'vue-chartjs';

export default {
  name: 'PieChart',
  extends: Pie,
  props: {
    width: {
      type: Number,
      default: 150
    },
    height: {
      type: Number,
      default: 150
    },
    label: {
        type: Array,
    },
    chartData: {
        type: Object,
        required: true,
    },
    options: {
        type: Object,
    },
  },
  data() {
    return {
    }
  },
  watch: {
    chartData: function (newVal, OldVal) {
      this.updateChart()
    },
  },
  mounted() {
    this.updateChart()
  },
  methods: {
    updateChart() {
      if (this.$data._chart) {
        this.$data._chart.destroy();
      }
      this.renderChart(
        {
          labels: this.chartData.labels,
          datasets : this.chartData.datasets
        },
        this.options
      );
    }
  }
}
</script>
    



// WEBPACK FOOTER //
// src/components/Partials/PieChart.vue